export default __webpack_public_path__ + "static/media/measurement-background.1696f125.jpg";